import { getAuthHeaders, tempMeeApi as api } from '~/services/api';
import { IAcceptGoTuTermsPayload, IAcceptGoTuTermsResponse } from './acceptGoTuTermsTypes';

const acceptGoTuTerms = async ({
  officeId,
  accessToken,
}: IAcceptGoTuTermsPayload): Promise<IAcceptGoTuTermsResponse> => {
  const baseHeaders = accessToken
    ? { Authorization: accessToken }
    : await getAuthHeaders();

  const response = await api.post<IAcceptGoTuTermsResponse>(
    '/user/tos/gotu',
    {},
    {
      headers: {
        ...baseHeaders,
        ...(officeId ? { 'x-office': officeId } : {}),
      },
    },
  );

  return response.data;
};

export const acceptGoTuTermsApi = {
  acceptGoTuTerms,
};
